import React from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import {
  TableData,
  UserDetails,
  Username,
  UserDescription,
  StopIcon,
  PrivateData,
  MainContent,
  UserTime,
  Circle,
  Div,
  Line,
  Header,
  BottomDiv,
  LeftBlock,
  SvgDiv,
  RightBlock,
  MiddleLine,
  SliderBox,
  DateTitle,
  TimeTitle
} from './styles';
import { getUniqueId } from '../../../helpers/common';
import { ICON_SIZE } from '../../../global/constants';
const TimeTrackingLoading: React.FC = () => {
  return (
    <MainContent>
      <Header>
        <LeftBlock>
          <SvgDiv>
            <SVGIcon
              name='new-back-arrow-icon'
              width={ICON_SIZE.XL}
              height={ICON_SIZE.XL}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-secondary)'
            />
          </SvgDiv>
        </LeftBlock>
        <MiddleLine>
          {Array(7)
            .fill(null)
            .map((_, i) => (
              <div key={getUniqueId()} className={`box ${i > 4 ? 'last-box' : ''}`}>
                <SliderBox>
                  <DateTitle className='loading-animation' />
                  <TimeTitle className='loading-animation' />
                </SliderBox>
              </div>
            ))}
        </MiddleLine>
        <RightBlock>
          <SvgDiv>
            <SVGIcon
              name='updated-right-arrow-icon'
              width={ICON_SIZE.XL}
              height={ICON_SIZE.XL}
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-secondary)'
            />
          </SvgDiv>
        </RightBlock>
      </Header>
      <BottomDiv>
        <TableData>
          <UserDetails>
            <Username className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserTime className='loading-animation' />
            <Div>
              <StopIcon>
                <SVGIcon
                  name='time-loading-icon'
                  width={ICON_SIZE.XXXXL}
                  height={ICON_SIZE.XXXXL}
                  viewBox={`0 0 ${ICON_SIZE.XXXXL} ${ICON_SIZE.XXXXL}`}
                  className='loading-icon'
                />
              </StopIcon>
              <Line />
              <Circle className='loading-animation' />
            </Div>
          </PrivateData>
        </TableData>
        <TableData>
          <UserDetails>
            <Username className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserTime className='loading-animation' />
            <Div>
              <StopIcon>
                <SVGIcon
                  name='time-loading-icon'
                  width={ICON_SIZE.XXXXL}
                  height={ICON_SIZE.XXXXL}
                  viewBox={`0 0 ${ICON_SIZE.XXXXL} ${ICON_SIZE.XXXXL}`}
                  className='loading-icon'
                />
              </StopIcon>
              <Line />
              <Circle className='loading-animation' />
            </Div>
          </PrivateData>
        </TableData>
        <TableData>
          <UserDetails>
            <Username className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserTime className='loading-animation' />
            <Div>
              <StopIcon>
                <SVGIcon
                  name='time-loading-icon'
                  width={ICON_SIZE.XXXXL}
                  height={ICON_SIZE.XXXXL}
                  viewBox={`0 0 ${ICON_SIZE.XXXXL} ${ICON_SIZE.XXXXL}`}
                  className='loading-icon'
                />
              </StopIcon>
              <Line />
              <Circle className='loading-animation' />
            </Div>
          </PrivateData>
        </TableData>
      </BottomDiv>
    </MainContent>
  );
};

export default TimeTrackingLoading;
